import { render, staticRenderFns } from "./KnowledgeEditorMainTitle.vue?vue&type=template&id=12769b9a&scoped=true&"
import script from "./KnowledgeEditorMainTitle.vue?vue&type=script&lang=js&"
export * from "./KnowledgeEditorMainTitle.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeEditorMainTitle.vue?vue&type=style&index=0&id=12769b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12769b9a",
  null
  
)

export default component.exports